import { useMutation } from 'react-query';
import {
  createSportHallAsync,
  deleteSportHallAsync,
  getSportHallAsync,
  updateSportHallAsync,
} from '../../index';

export const useCreateSportHall = () => useMutation(createSportHallAsync);

export const useUpdateSportHall = () => useMutation(updateSportHallAsync);

export const useDeleteSportHall = () => useMutation(deleteSportHallAsync);

export const useGetSportHall = () => useMutation(getSportHallAsync);
